var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 7H1.5L7.5 1L13.5 7H12.1667",
    stroke: "#FF9668",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 7V11.6667C2.8335 12.0203 2.97397 12.3594 3.22402 12.6095C3.47407 12.8595 3.81321 13 4.16683 13H10.8335C11.1871 13 11.5263 12.8595 11.7763 12.6095C12.0264 12.3594 12.1668 12.0203 12.1668 11.6667V7",
    stroke: "#FF9668",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.9998V8.99984C5.5 8.64622 5.64048 8.30708 5.89052 8.05703C6.14057 7.80698 6.47971 7.6665 6.83333 7.6665H8.16667C8.52029 7.6665 8.85943 7.80698 9.10947 8.05703C9.35952 8.30708 9.5 8.64622 9.5 8.99984V12.9998",
    stroke: "#FF9668",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.04be1384927a03ea370ea324ba385ddf.svg";
export { ForwardRef as ReactComponent };